import React from 'react';
import { Cloud, RefreshCw, GitBranch, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 z-0"
        style={
          {
            backgroundImage: 'url(https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }
        }
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/90 to-gray-900/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40">
        <div className="max-w-4xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Building Scalable, Secure, and Automated
            <span className="block text-blue-400 mt-2">IT Environments</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            We help organizations accelerate innovation through DevOps, Cloud, and Automation solutions built on AWS, Azure, and modern CI/CD practices.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6"
              onClick={scrollToContact}
            >
              Let's Transform Your Infrastructure
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 text-lg px-8 py-6"
              onClick={() => window.open('https://www.upwork.com/freelancers/~01f154b41379ec1c68?mp_source=share', '_blank')}
            >
              Hire Us on Upwork
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-start space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <Cloud className="text-blue-400 flex-shrink-0 mt-1" size={28} />
              <div>
                <h3 className="text-white font-semibold mb-1">Cloud Expertise</h3>
                <p className="text-gray-300 text-sm">Certified AWS & Azure architects</p>
              </div>
            </div>

            <div className="flex items-start space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <RefreshCw className="text-blue-400 flex-shrink-0 mt-1" size={28} />
              <div>
                <h3 className="text-white font-semibold mb-1">DevOps Automation</h3>
                <p className="text-gray-300 text-sm">Faster releases, fewer errors</p>
              </div>
            </div>

            <div className="flex items-start space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <GitBranch className="text-blue-400 flex-shrink-0 mt-1" size={28} />
              <div>
                <h3 className="text-white font-semibold mb-1">CI/CD Pipelines</h3>
                <p className="text-gray-300 text-sm">Seamless integration & delivery</p>
              </div>
            </div>

            <div className="flex items-start space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <Shield className="text-blue-400 flex-shrink-0 mt-1" size={28} />
              <div>
                <h3 className="text-white font-semibold mb-1">Security First</h3>
                <p className="text-gray-300 text-sm">End-to-end protection</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
